{
  "DisplayAsLabel": "Visualizzare come:",
  "ColorTileBackgroundLabel": "Colore delle piastrelle:",
  "ColorTileTextLabel": "Colore del testo:",
  "FitImageLabel": "Immagine in forma",
  "DisplayTitleLabel": "Visualizzare l'area di testo del titolo",
  "AutoValuePlaceholder": "[Auto]",
  "ImageUrlPlaceholder": "https:\/\/example.com\/image.png",
  "ImageUrlLabel": "URL immagine:",
  "Black": "Nero",
  "White": "Bianco",
  "Blanc": "Bianco",
  "Smoke": "Fumo",
  "Grey": "Grigio",
  "Battleship": "Corazzata",
  "Aqua": "Acqua",
  "Blue": "Blu",
  "Waters": "Acque",
  "Sky": "Il cielo",
  "Akixi": "Akixi",
  "Midnight": "Mezzanotte",
  "Pistachio": "Pistacchio",
  "Green": "Verde",
  "Forest": "Foresta",
  "Salmon": "Salmone",
  "Red": "Rosso",
  "Rosita": "Rosita",
  "Peach": "Pesca",
  "Orange": "Arancione",
  "Clementine": "Clementina",
  "Amarelo": "Amarelo",
  "Yellow": "Giallo",
  "Sunflower": "Girasole",
  "Lilac": "Lilla",
  "Purple": "Viola",
  "Regal": "Regale",
  "Blush": "Blush",
  "Pink": "Rosa",
  "Fuchsia": "Fucsia",
  "Caribbean": "Caraibi",
  "Teal": "Verde acqua",
  "Peacock": "Pavone",
  "SimpleTextValue": "[Valore del testo semplice]",
  "ProgressRing": "Anello del progresso",
  "GradatedDial": "Quadrante graduato",
  "GlideSlope": "Pendenza di scorrimento",
  "Bullseye": "Occhio di bue",
  "BarGauge": "Misuratore di bar",
  "ConeGauge": "Calibro a cono",
  "DashboardSpeedometerBlack": "Tachimetro da cruscotto (nero)",
  "DashboardSpeedometerAmber": "Tachimetro del cruscotto (ambra)",
  "DashboardTemperatureGauge": "Indicatore di temperatura sul cruscotto",
  "DashboardFuelGauge": "Indicatore del carburante sul cruscotto",
  "DashboardPowerGauge": "Indicatore di potenza del cruscotto",
  "DashboardColourGauge": "Indicatore di colore del cruscotto",
  "GaugeFaceLabel": "Invertire la faccia del calibro:",
  "GaugeFaceDirection": "Invertire la direzione del calibro:",
  "MaxScaleLabel": "Scala massima:",
  "DisplayPreviewCaption": "Anteprima:",
  "DisplaySettings_SectionHeader": "Impostazioni del display",
  "NAME": "DisplaySettings",
  "VividSky": "Cielo vivido",
  "ElectricIndigo": "Indaco elettrico",
  "OxfordBlue": "Blu Oxford",
  "Aquamarine": "Acquamarina"
}